
    <p-fileUpload
      #primeUpload
      name="file[]"
      (uploadHandler)="uploadDocument($event)"
      (onRemove)="removeEvent($event)"
      customUpload="true"
      [multiple]="multiple"
      [accept]="accept"
      maxFileSize="1000000000"
      [chooseLabel]="chooseLabel"
      [uploadLabel]="uploadLabel"
      [showUploadButton]="showUploadButton"
      [showCancelButton]="showCancelButton"
      [disabled]="disabled"
      [auto]="isAutoUpload"
      (onSelect)="onFileSelected($event)"
      (onClear)="cancelAllDocuments()"
    >
      <ng-template pTemplate="file" let-file let-index="index">
        <div class="file-item">
          <div class="file-name">
            {{ file.name }}
          </div>

          <div class="file-size">
            {{ bytesToSize(file.size) }}
          </div>

          <button
            [disabled]="uploadStarted"
            type="button"
            class="remove-btn"
            (click)="removeFileManually(index, primeUpload, file)"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
      </ng-template>
    </p-fileUpload>
  